import { Link } from "react-router-dom";
import { MapPin, ArrowUpRight } from "lucide-react";
import { Reveal, MaskedLines } from "@/components/site/Reveal";
import { CAREERS } from "@/data/pageCopy";


const { kicker, h1Lines, lead, perks, roles } = CAREERS;

export default function Careers() {
  return (
    <div data-testid="careers-page">
      <section className="relative pt-32 md:pt-40 pb-20 overflow-hidden">
        <div className="pointer-events-none absolute inset-0 opacity-[0.05]" style={{
          backgroundImage: "linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)",
          backgroundSize: "64px 64px",
        }} />
        <div className="relative mx-auto max-w-[1400px] px-6 md:px-12">
          <Reveal><p className="font-mono-t text-xs uppercase tracking-[0.25em] text-[#5B8CFF] mb-5">{kicker}</p></Reveal>
          <h1 className="font-heading font-medium tracking-tight leading-[0.98] text-4xl md:text-6xl lg:text-7xl text-white max-w-4xl">
            <MaskedLines lines={h1Lines} delay={0.1} />
          </h1>
          <Reveal delay={0.35}>
            <p className="mt-8 text-lg text-neutral-400 max-w-2xl leading-relaxed">
              {lead}
            </p>
          </Reveal>
        </div>
      </section>

      <section className="py-16 border-t border-white/10">
        <div className="mx-auto max-w-[1400px] px-6 md:px-12 grid md:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {perks.map((p) => (
            <div key={p.t} className="bg-white/[0.02] p-7">
              <p.icon className="text-white" size={24} />
              <h3 className="mt-4 font-heading font-semibold text-lg text-white">{p.t}</h3>
              <p className="mt-2 text-neutral-500 text-sm leading-relaxed">{p.d}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="py-20 border-t border-white/10">
        <div className="mx-auto max-w-[1400px] px-6 md:px-12">
          <Reveal>
            <h2 className="font-heading font-medium tracking-tight text-3xl md:text-4xl text-white">Open roles</h2>
            <p className="mt-3 text-neutral-500">{roles.length} positions · we review every application.</p>
          </Reveal>
          <div className="mt-10 border border-white/10 bg-white/[0.02]">
            {roles.map((r, i) => (
              <Reveal key={r.title} delay={(i % 6) * 0.04}>
                <Link
                  to="/demo"
                  className="group flex flex-col md:flex-row md:items-center justify-between gap-3 px-6 py-6 border-b border-white/10 last:border-0 hover:bg-white/[0.05] transition-colors"
                  data-testid={`role-${i}`}
                >
                  <div>
                    <h3 className="font-heading font-semibold text-lg text-white">{r.title}</h3>
                    <p className="mt-1 font-mono-t text-xs uppercase tracking-widest text-neutral-500">{r.team}</p>
                  </div>
                  <div className="flex items-center gap-6">
                    <span className="text-sm text-neutral-400">{r.type}</span>
                    <span className="flex items-center gap-1.5 text-sm text-neutral-400"><MapPin size={14} /> {r.loc}</span>
                    <ArrowUpRight size={18} className="text-neutral-300 group-hover:text-white group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all" />
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
          <p className="mt-6 text-sm text-neutral-500">
            Don't see your role? <Link to="/demo" className="text-white underline underline-offset-4">Reach out anyway</Link>.
          </p>
        </div>
      </section>
    </div>
  );
}
